import { configureStore } from "@reduxjs/toolkit";
import mainStoreReducer from "./slices/mainStore";
export const store = configureStore({
  reducer: {
    formData: mainStoreReducer,
  },
});
